import { getBreakpoint } from '../utils/breakpoint-util';

function iframeOverlayClass(target) {
    this.target = target;
    this.iframeContainerSelector = '.jsIframeContainer';
    this.iframeOverlaySelector = '.jsIframeOverlay';
    this.closeButtonSelector = '.jsIframeCloseOverlay';
    this.iframeLoaderSelector = '.jsIframeLoader';
    this.iframeSelector = '.jsIframe';
    this.closeButtonElement = null;
    this.resizedClass = 'iframeIsResized';
    this.iframeOverlayIsActiveClass = 'iframeOverlayIsActive';
    this.queryString = this.target.getAttribute('data-iframe-querystring');
    this.html = 
        '<div class="c-iframe-overlay jsIframeContainer">'+
            '<div class="c-iframe-overlay__iframe jsIframeOverlay">'+
                '<div class="c-iframe-overlay__loader jsIframeLoader"><div class="c-loader"></div></div>'+
                '<div class="c-iframe-overlay__iframe__close jsIframeCloseOverlay"></div>'+
                '<iframe src="{{src}}" width="100%" height="100%" marginheight="0" marginwidth="0" frameborder="0" scrolling="no" class="jsIframe"></iframe>'+
            '</div>'+
        '</div>';

    // Reference bound functions
    this.addResizeEventHandler = this.addResizeEventHandler.bind(this);
    this.closeButtonEventHandler = this.closeButtonEventHandler.bind(this);
    this.closeWhenClickedOutsideOfIframeEventHandler = this.closeWhenClickedOutsideOfIframeEventHandler.bind(this);

    this.init();
}

/*
    * addResizeEventHandler
    * 
    * Handler for the addResizeEventListener function
    * Resizes the iframe overlay element with the dimensions from the postMessage from the iframed page
    */

iframeOverlayClass.prototype.addResizeEventHandler = function(e) {
    if(e.data['iframeOverlay'] && e.data['height']) {
        var iframeOverlay = document.querySelector(this.iframeOverlaySelector);
        iframeOverlay.style.height = e.data['height'] + 'px';
        iframeOverlay.classList.add(this.resizedClass);
    }
}

/*
    * addResizeEventListener
    * 
    * Listens for the message event coming from the iframed page
    */

iframeOverlayClass.prototype.addResizeEventListener = function() {
    window.addEventListener('message', this.addResizeEventHandler);
}

/*
    * removeResizeEventListener
    * 
    * Remove the event listener for the event coming from the iframed page
    */

iframeOverlayClass.prototype.removeResizeEventListener = function() {
    window.removeEventListener('message', this.addResizeEventHandler);
}

/*
    * closeButtonEventHandler
    * 
    * Handler for the addCloseButtonEventListener
    * Closes the the iframe overlay
    */

iframeOverlayClass.prototype.closeButtonEventHandler = function(e) {
    // Remove the listener on the close button
    this.removeCloseButtonEventListener();
    // Remove the postMessage listener
    this.removeResizeEventListener();
    
    this.toggleOverflowingBody();
    this.removeCloseWhenClickedOutsideOfIframeEventListener();

    // Remove the overlay element
    var iframe = document.querySelector(this.iframeContainerSelector);
    var parent = iframe.parentNode;
    parent.removeChild(iframe);

    e.preventDefault();
}

/*
    * addCloseButtonEventListener
    * 
    * Listens for the click even on the close button
    */

iframeOverlayClass.prototype.addCloseButtonEventListener = function() {
    this.closeButtonElement = document.querySelector(this.closeButtonSelector);
    this.closeButtonElement.addEventListener('click', this.closeButtonEventHandler);
}

/*
    * removeCloseButtonEventListener
    * 
    * Removes the click event on the close button
    */

iframeOverlayClass.prototype.removeCloseButtonEventListener = function() {
    this.closeButtonElement.removeEventListener('click', this.closeButtonEventHandler);
}

/*
    * toggleOverflowingBody
    * 
    * Adds a class to the html element to disable the window scrollbar
    */

iframeOverlayClass.prototype.toggleOverflowingBody = function() {
    document.querySelector('html').classList.toggle(this.iframeOverlayIsActiveClass);
}

/*
    * hideLoader
    * 
    * Hides the loader after the iframe has loaded
    */

iframeOverlayClass.prototype.hideLoader = function() {
    var that = this;

    var iframe = document.querySelector(this.iframeSelector);
    iframe.onload = function() {
        document.querySelector(that.iframeLoaderSelector).style.display = 'none';
    };
}

/*
    * render
    * 
    * Renders the html for the iframe overlay
    */

iframeOverlayClass.prototype.render = function() {
    var src = this.target.getAttribute('href') + this.queryString;
    this.html = this.html.replace('{{src}}', src);
    document.querySelector('body').insertAdjacentHTML('beforeend', this.html);
}

/*
    * closeWhenClickedOutsideOfIframeEventHandler
    * 
    * Hides the overlay when clicked outside of the iframe
    */

iframeOverlayClass.prototype.closeWhenClickedOutsideOfIframeEventHandler = function(e) {
    if (e.target.classList.contains('jsIframeContainer')) {
        this.closeButtonEventHandler(e);
    }
}

/*
    * removeCloseWhenClickedOutsideOfIframeEventListener
    * 
    * Removes click event on iframe container
    */

iframeOverlayClass.prototype.removeCloseWhenClickedOutsideOfIframeEventListener = function() {
    document.removeEventListener('click', this.closeWhenClickedOutsideOfIframeEventHandler);
}

/*
    * addCloseWhenClickedOutsideOfIframeEventListener
    * 
    * Adds click event on iframe container
    */

iframeOverlayClass.prototype.addCloseWhenClickedOutsideOfIframeEventListener = function() {
    document.addEventListener('click', this.closeWhenClickedOutsideOfIframeEventHandler);
}

/*
    * init
    * 
    * Initialize the overlay
    */

iframeOverlayClass.prototype.init = function() {
    var that = this;

    this.addResizeEventListener();
    this.render();
    this.hideLoader();
    this.addCloseButtonEventListener();
    this.toggleOverflowingBody();
    this.addCloseWhenClickedOutsideOfIframeEventListener();
}

// Delegate the click event for elements with the rel="openIframeInOverlay" attribute
document.querySelector('body').addEventListener('click', function(e) {
    if (getBreakpoint() != 'mobile' && e.target.getAttribute('data-iframe-overlay') === 'True') {
        var instance = new iframeOverlayClass(e.target);
        e.preventDefault();
    }
});